"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cnbuilder = require("cnbuilder");
var _dist = require("react-day-picker/dist");
var _ArrowNavigation = _interopRequireDefault(require("./ArrowNavigation"));
var _DropdownNavigation = _interopRequireDefault(require("./DropdownNavigation"));
var _HeaderModule = _interopRequireDefault(require("./Header.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const Header = _ref => {
  let {
    displayMonth
  } = _ref;
  const {
    classNameHeader,
    testAttrHeader,
    captionLayout,
    fromDate,
    toDate
  } = (0, _dist.useDayPicker)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _cnbuilder.cnb)(_HeaderModule.default.root, classNameHeader),
    "data-test": testAttrHeader,
    children: captionLayout === 'dropdown' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownNavigation.default, {
      date: displayMonth,
      fromDate: fromDate,
      toDate: toDate
    }, displayMonth) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowNavigation.default, {
      date: displayMonth
    })
  });
};
var _default = exports.default = Header;